<template>
   <main id="event_body">
    <div class="myPost_wrapper" id="more_board">
      <!-- title -->
      <div class="main_top">
        <h1 ><img src ="images/basic/icon/back.svg" onclick="history.back()" class="back">
          {{eventTitle}}
        </h1>
        <span style="color:var(--Main-color); font-weight:bold" @click="goToWinnerList()">지난회차</span>      
      </div>
    
      <div class="div_padding"></div>
       <!-- 
         //[2]
         imported 된 컴포넌트들 사용
        -->
      <EventBannerForm :bannerImg="bannerImg"></EventBannerForm>
      <LottoTrxForm 
      :accountCoin="accountCoin"
      :todayMission="todayMission"
      :dailyCheck="dailyCheck"
      :adCntCheck="adCntCheck"
      :commentCheck="commentCheck"
      :refereeMission="refereeMission"
      :openDate ="openDate"
      :openTime ="openTime"
      :endDate  ="endDate"
      :endTime  ="endTime"
      
      ></LottoTrxForm>
      <LottoInfoForm 
      :eventTitle      ="eventTitle"
      :eventDesc       ="eventDesc"
      :openDate        ="openDate"
      :openTime        ="openTime"
      :endDate         ="endDate"
      :endTime         ="endTime"
      :winnerGift      ="winnerGift"
      :eventHowto      ="eventHowto"
      :winnerOpenDate  ="winnerOpenDate"
      :winnerOpenTime  ="winnerOpenTime"
      :winnerCondition ="winnerCondition"
      :joinListCnt     ="joinListCnt"
      ></LottoInfoForm>
    </div>
  </main>
</template>

<script>
/**
 * step. 1
 * 먼저 각각 파편화된 component 들을 import 해줍니다.
 * ex).
 * export defualt {
 *  componant: {
 *    <some imported component>,
 *    <some imported component>
 *  }
 * }
 * 
 * step. 2
 * imported 된 컴포넌트를 template tag 안에서
 * 자유롭게 해당 componant 명으로 자유롭게 사용 가능합니다.
 * @EventBannerForm = 상단 배너 componant
 * @LottoEventForm = 중단 로또 게임 componant
 * @EventInfoForm = 이벤트 정보 componant
 */
//[1]
import EventBannerForm from './common/EventBannerForm.vue'
import LottoTrxForm from './lotto/LottoTrxForm.vue'
import LottoInfoForm from './lotto/LottoInfoForm.vue'
import { fetchInfomation, fetchAdCheck, requestCreate, requestUse, fetchJoinList, fetchWinnerInfo } from '@/api/ngame'
export default {
  components: {
    EventBannerForm,
    LottoTrxForm,
    LottoInfoForm
  },
  created() {
    this.fetchData();
  },
  methods:{
    goToWinnerList(){
      this.$router.push({
        path: '/lottoWinnerList', query: {
          eventId: this.$route.query.eventId
        }
      })
    },
    fetchData(){
      fetchInfomation({
        eventId: this.$route.query.eventId
      })
      .then(({ data }) => {
        console.log(data);
        this.eventInfo = data.info;
        let result = data.info
        this.bannerImg       = result.imageUrl;
        this.eventTitle      = result.eventTitle     
        this.eventDesc       = result.eventDesc  
        this.openDate        = result.openDate       
        this.openTime        = result.openTime       
        this.endDate         = result.endDate        
        this.endTime         = result.endTime        
        this.winnerGift      = result.winnerGift     
        this.eventHowto      = result.eventHowto     
        this.winnerOpenDate  = result.winnerOpenDate 
        this.winnerOpenTime  = result.winnerOpenTime 
        this.winnerCondition = result.winnerCondition

        this.todayMission    = result.missionInfo.todayMission
        this.dailyCheck      = result.missionInfo.dailyCheck
        this.adCntCheck      = result.missionInfo.adCntCheck
        this.commentCheck    = result.missionInfo.commentCheck
        this.refereeMission  = result.missionInfo.refereeMission
      
      })
      .then(() => {
        this.fetchJoinList();
      })
    },
    fetchJoinList(){
      fetchJoinList({
        eventId: this.$route.query.eventId,
        pageIndex: 1
      })
      .then(({ data }) => {
        this.joinListCnt = data.joinListCnt;
      })
    }
  },
  data() {
    return {
      eventInfo: {},
      bannerImg:       '',
      joinCnt: 0,
      eventTitle:      '',
      eventDesc:       '',
      openDate:        '',
      openTime:        '',
      endDate:         '',
      endTime:         '',
      winnerGift:      '',
      eventHowto:      '',
      winnerOpenDate:  '',
      winnerOpenTime:  '',
      winnerCondition: '',
      accountCoin:     '',
      joinListCnt:      0,
      // mission info
      todayMission:    'N',
      dailyCheck:      'N',
      adCntCheck:      'N',
      commentCheck:    'N',
      refereeMission:  'N',
    }
  },
}
</script>

<style>

</style>